/**
 * Created by nicom on 5/2/2017.
 */

import React, { Component } from "react";
import "../../css/Hours.css";
import WorkedHourItem from "../AdminData/WorkedHourItem";
class HoursList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hourListData: this.props.hourListData.slice(0, 1),
    };
    this.renderWorkedHourItems = this.renderWorkedHourItems.bind(this);
    this.recursive = this.recursive.bind(this);
  }

  recursive = () => {
    setTimeout(() => {
      const hasMore =
        this.state.hourListData.length + 1 < this.props.hourListData.length;
      this.setState((prev, props) => ({
        hourListData: props.hourListData.slice(0, prev.hourListData.length + 1),
      }));
      if (hasMore) this.recursive();
    }, 0);
  };

  componentDidMount() {
    this.recursive();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.hourListData !== this.props.hourListData) {
      this.recursive();
    }
  }

  renderWorkedHourItems() {
    return this.state.hourListData.map((dayData, index) => {
      const { FreeDayType, fetchData } = this.props;
      return (
        <WorkedHourItem
          isLoading={this.props.isLoading}
          key={dayData.Day.Date + index}
          timeFormat={this.props.timeFormat}
          dayData={dayData}
          projectHelper={this.props.projectHelper}
          FreeDayType={FreeDayType}
          fetchData={fetchData}
        />
      );
    });
  }
  render() {
    return (
      <div className="listContainer">
        <div>{this.renderWorkedHourItems()}</div>
      </div>
    );
  }
}

export default HoursList;
